import { handleActions } from 'redux-actions';
import { elementDatapartStoreAction } from 'store/actions/statement-content-actions';
import ElementDataParts from 'models/api/element-dataparts-model';

export default handleActions(
  {
    [elementDatapartStoreAction]: (dataPartsModel, { payload }) => {
      const { response } = payload;
      return dataPartsModel.updateDatapartElements({ response });
    },
  },
  new ElementDataParts(),
);
